"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PingService = void 0;
class PingService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1Ping() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/Ping',
        });
    }
}
exports.PingService = PingService;
